import { InjectionToken } from "@angular/core";

export const USER_DEFAULTS = new InjectionToken("ui-kit-datepicker-defaults");
